import {ValidationSummary} from 'devextreme-react/validation-summary';
import {Box, Item} from 'devextreme-react/box';
import Toolbar, {Item as ToolbarItem} from 'devextreme-react/toolbar';
import {
    CloseLeadButton,
    CreateEstimateButton,
    CreateRevisionButton,
    EstimateAddNoteButton,
    EstimateDatesPanel,
    EstimateFilesButton,
    EstimateInformationCards,
    EstimateItemsGrid,
    EstimateNotesPanel,
    EstimatePage,
    EstimateProgress,
    ExitButton,
    SetToPendingButton
} from '../../../features/cfi/estimate';
import '../../../css/order.scss';

export default function EstimateSubmitEstimatePage() {

	return (
		<EstimatePage>

			<EstimateInformationCards />

			<EstimateProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<CreateEstimateButton />
					<CreateRevisionButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<SetToPendingButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<EstimateFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<CloseLeadButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<EstimateAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<EstimateDatesPanel />
				</Item>
				<Item ratio={1}>
					<EstimateNotesPanel height={200} />
				</Item>
			</Box>

			<EstimateItemsGrid />

		</EstimatePage>
	)
}
